var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getComponentProps } from './utils';
import React from 'react';
import { TextSize } from './typography.type';
/**
 * @deprecated Use Typography variant="subtitle1|title3"
 */
export var TextLG = function (_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "component"]);
    return (React.createElement(Component, __assign({}, getComponentProps({ size: TextSize.lg })(props)), children));
};
/**
 * @deprecated Use Typography variant="label1|body1"
 */
export var TextMD = function (_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "component"]);
    return (React.createElement(Component, __assign({}, getComponentProps({ size: TextSize.md })(props)), children));
};
/**
 * @deprecated Use Typography variant="link|body2"
 */
export var TextSM = function (_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "component"]);
    return (React.createElement(Component, __assign({}, getComponentProps({ size: TextSize.sm })(props)), children));
};
/**
 * @deprecated Use Typography variant="body3|label2"
 */
export var TextXS = function (_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "component"]);
    return (React.createElement(Component, __assign({}, getComponentProps({ size: TextSize.xs })(props)), children));
};
/**
 * @deprecated Use Typography variant="body4"
 */
export var TextXXS = function (_a) {
    var children = _a.children, _b = _a.component, Component = _b === void 0 ? 'span' : _b, props = __rest(_a, ["children", "component"]);
    return (React.createElement(Component, __assign({}, getComponentProps({ size: TextSize.xxs })(props)), children));
};
